
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2'; ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default function BarCharts(props) {
    return (
        <div style={{
            width: '100%', margin: '10px auto 0', height: '100%',
            // boxShadow: " rgba(0, 0, 0, 0.16) 0px 1px 4px", borderRadius: '10px', backgroundColor: '#fcfcfc',

        }}>
            <Bar data={props.data} options={props.options} />
        </div >
    );
}